// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adf-pdf-viewer .textLayer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1;
  border: 1px solid gray;
}
.adf-pdf-viewer .textLayer > div {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
.adf-pdf-viewer .textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(180, 0, 170);
  border-radius: 4px;
}
.adf-pdf-viewer .textLayer .highlight.begin {
  border-radius: 4px 0px 0px 4px;
}
.adf-pdf-viewer .textLayer .highlight.end {
  border-radius: 0px 4px 4px 0px;
}
.adf-pdf-viewer .textLayer .highlight.middle {
  border-radius: 0px;
}
.adf-pdf-viewer .textLayer .highlight.selected {
  background-color: rgb(0, 100, 0);
}
.adf-pdf-viewer .textLayer::selection {
  background: rgb(0, 0, 255);
}
.adf-pdf-viewer .textLayer::-moz-selection {
  background: rgb(0, 0, 255);
}
.adf-pdf-viewer .textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0px;
  top: 100%;
  right: 0px;
  bottom: 0px;
  z-index: -1;
  cursor: default;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}
.adf-pdf-viewer .textLayer .endOfContent.active {
  top: 0px;
}
.adf-pdf-viewer .annotationLayer section {
  position: absolute;
}
.adf-pdf-viewer .annotationLayer .linkAnnotation > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7") 0 0 repeat;
}
.adf-pdf-viewer .annotationLayer .linkAnnotation > a:hover {
  opacity: 0.2;
  background: #ff0;
  box-shadow: 0px 2px 10px #ff0;
}
.adf-pdf-viewer .annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
}
.adf-pdf-viewer .annotationLayer .popupWrapper {
  position: absolute;
  width: 20em;
}
.adf-pdf-viewer .annotationLayer .popup {
  position: absolute;
  z-index: 200;
  max-width: 20em;
  background-color: #FFFF99;
  box-shadow: 0px 2px 5px #333;
  border-radius: 2px;
  padding: 0.6em;
  margin-left: 5px;
  cursor: pointer;
  word-wrap: break-word;
}
.adf-pdf-viewer .annotationLayer .popup h1 {
  font-size: 1em;
  border-bottom: 1px solid #000000;
  padding-bottom: 0.2em;
}
.adf-pdf-viewer .annotationLayer .popup p {
  padding-top: 0.2em;
}
.adf-pdf-viewer .annotationLayer .highlightAnnotation,
.adf-pdf-viewer .annotationLayer .underlineAnnotation,
.adf-pdf-viewer .annotationLayer .squigglyAnnotation,
.adf-pdf-viewer .annotationLayer .strikeoutAnnotation,
.adf-pdf-viewer .annotationLayer .fileAttachmentAnnotation {
  cursor: pointer;
}
.adf-pdf-viewer .pdfViewer canvasWrapper {
  overflow: hidden;
}
.adf-pdf-viewer .pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: 1px auto -8px auto;
  position: relative;
  overflow: visible;
  border: 9px solid transparent;
  background-clip: content-box;
  background-color: white;
}
.adf-pdf-viewer .pdfViewer .page canvas {
  margin: 0;
  display: block;
}
.adf-pdf-viewer .pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.adf-pdf-viewer .pdfViewer .page * {
  padding: 0;
  margin: 0;
}
.adf-pdf-viewer .pdfViewer.removePageBorders .page {
  margin: 0px auto 10px auto;
  border: none;
}
.adf-pdf-viewer .pdfViewer .loadingIcon {
  width: 100px;
  height: 100px;
  left: 50% !important;
  top: 50% !important;
  margin-top: -50px;
  margin-left: -50px;
  font-size: 5px;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(3, 0, 2, 0.2);
  border-right: 1.1em solid rgba(3, 0, 2, 0.2);
  border-bottom: 1.1em solid rgba(3, 0, 2, 0.2);
  border-left: 1.1em solid #030002;
  transform: translateZ(0);
  animation: load8 1.1s infinite linear;
  border-radius: 50%;
}
.adf-pdf-viewer .pdfViewer .loadingIcon:after {
  border-radius: 50%;
}
.adf-pdf-viewer .hidden, .adf-pdf-viewer [hidden] {
  display: none !important;
}
@keyframes load8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.viewer-pdf-viewer {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  outline: none;
}

html[dir=ltr] .viewer-pdf-viewer {
  box-shadow: inset 1px 0 0 hsla(0, 0%, 100%, 0.05);
}

html[dir=rtl] .viewer-pdf-viewer {
  box-shadow: inset -1px 0 0 hsla(0, 0%, 100%, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/components/pdfViewerHost.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EAKA,uBAAA;AAAZ;AAGQ;EACI,YAAA;EACA,YAAA;EAEA,kCAAA;EACA,kBAAA;AAFZ;AAIY;EACI,8BAAA;AAFhB;AAKY;EACI,8BAAA;AAHhB;AAMY;EACI,kBAAA;AAJhB;AAOY;EACI,gCAAA;AALhB;AASQ;EAAe,0BAAA;AANvB;AAOQ;EAAoB,0BAAA;AAJ5B;AAMQ;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAJZ;AAMY;EACI,QAAA;AAJhB;AAUQ;EACI,kBAAA;AARZ;AAYY;EACI,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,4GAAA;AAVhB;AAYgB;EACI,YAAA;EACA,gBAAA;EACA,6BAAA;AAVpB;AAgBY;EACI,kBAAA;EACA,eAAA;AAdhB;AAkBQ;EACI,kBAAA;EACA,WAAA;AAhBZ;AAmBQ;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAjBZ;AAmBY;EACI,cAAA;EACA,gCAAA;EACA,qBAAA;AAjBhB;AAoBY;EACI,kBAAA;AAlBhB;AAsBQ;;;;;EAKI,eAAA;AApBZ;AAyBQ;EACI,gBAAA;AAvBZ;AA0BQ;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;AAxBZ;AA0BY;EACI,SAAA;EACA,cAAA;AAxBhB;AA2BY;EACI,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AAzBhB;AA4BY;EACI,UAAA;EACA,SAAA;AA1BhB;AA+BY;EACI,0BAAA;EACA,YAAA;AA7BhB;AAiCQ;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,kBAAA;EAEA,cAAA;EACA,oBAAA;EACA,0CAAA;EACA,4CAAA;EACA,6CAAA;EACA,gCAAA;EAGA,wBAAA;EAEA,qCAAA;EAEA,kBAAA;AAlCZ;AAmCY;EACI,kBAAA;AAjChB;AAwCI;EACI,wBAAA;AAtCR;AAoDA;EACI;IAEI,uBAAA;EAvCN;EAyCE;IAEI,yBAAA;EAvCN;AACF;AA0CA;EACI,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AAxCJ;;AA0CA;EACI,iDAAA;AAvCJ;;AAyCA;EACI,kDAAA;AAtCJ","sourcesContent":[".adf-pdf-viewer {\r\n    .textLayer {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        overflow: hidden;\r\n        opacity: 0.2;\r\n        line-height: 1.0;\r\n        border: 1px solid gray;\r\n\r\n        & > div {\r\n            color: transparent;\r\n            position: absolute;\r\n            white-space: pre;\r\n            cursor: text;\r\n            -webkit-transform-origin: 0% 0%;\r\n            -moz-transform-origin: 0% 0%;\r\n            -o-transform-origin: 0% 0%;\r\n            -ms-transform-origin: 0% 0%;\r\n            transform-origin: 0% 0%;\r\n        }\r\n\r\n        .highlight {\r\n            margin: -1px;\r\n            padding: 1px;\r\n\r\n            background-color: rgb(180, 0, 170);\r\n            border-radius: 4px;\r\n\r\n            &.begin {\r\n                border-radius: 4px 0px 0px 4px;\r\n            }\r\n\r\n            &.end {\r\n                border-radius: 0px 4px 4px 0px;\r\n            }\r\n\r\n            &.middle {\r\n                border-radius: 0px;\r\n            }\r\n\r\n            &.selected {\r\n                background-color: rgb(0, 100, 0);\r\n            }\r\n        }\r\n\r\n        &::selection { background: rgb(0,0,255); }\r\n        &::-moz-selection { background: rgb(0,0,255); }\r\n\r\n        .endOfContent {\r\n            display: block;\r\n            position: absolute;\r\n            left: 0px;\r\n            top: 100%;\r\n            right: 0px;\r\n            bottom: 0px;\r\n            z-index: -1;\r\n            cursor: default;\r\n            user-select: none;\r\n            -webkit-user-select: none;\r\n            -ms-user-select: none;\r\n            -moz-user-select: none;\r\n\r\n            &.active {\r\n                top: 0px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .annotationLayer {\r\n        section {\r\n            position: absolute;\r\n        }\r\n\r\n        .linkAnnotation {\r\n            & > a {\r\n                position: absolute;\r\n                font-size: 1em;\r\n                top: 0;\r\n                left: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n                background: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\") 0 0 repeat;\r\n\r\n                &:hover {\r\n                    opacity: 0.2;\r\n                    background: #ff0;\r\n                    box-shadow: 0px 2px 10px #ff0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .textAnnotation {\r\n            img {\r\n                position: absolute;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n\r\n        .popupWrapper {\r\n            position: absolute;\r\n            width: 20em;\r\n        }\r\n\r\n        .popup {\r\n            position: absolute;\r\n            z-index: 200;\r\n            max-width: 20em;\r\n            background-color: #FFFF99;\r\n            box-shadow: 0px 2px 5px #333;\r\n            border-radius: 2px;\r\n            padding: 0.6em;\r\n            margin-left: 5px;\r\n            cursor: pointer;\r\n            word-wrap: break-word;\r\n\r\n            h1 {\r\n                font-size: 1em;\r\n                border-bottom: 1px solid #000000;\r\n                padding-bottom: 0.2em;\r\n            }\r\n\r\n            p {\r\n                padding-top: 0.2em;\r\n            }\r\n        }\r\n\r\n        .highlightAnnotation,\r\n        .underlineAnnotation,\r\n        .squigglyAnnotation,\r\n        .strikeoutAnnotation,\r\n        .fileAttachmentAnnotation {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .pdfViewer {\r\n        canvasWrapper {\r\n            overflow: hidden;\r\n        }\r\n\r\n        .page {\r\n            direction: ltr;\r\n            width: 816px;\r\n            height: 1056px;\r\n            margin: 1px auto -8px auto;\r\n            position: relative;\r\n            overflow: visible;\r\n            border: 9px solid transparent;\r\n            background-clip: content-box;\r\n            background-color: white;\r\n\r\n            canvas {\r\n                margin: 0;\r\n                display: block;\r\n            }\r\n\r\n            .loadingIcon {\r\n                position: absolute;\r\n                display: block;\r\n                left: 0;\r\n                top: 0;\r\n                right: 0;\r\n                bottom: 0;\r\n            }\r\n\r\n            * {\r\n                padding: 0;\r\n                margin: 0;\r\n            }\r\n        }\r\n\r\n        &.removePageBorders {\r\n            .page {\r\n                margin: 0px auto 10px auto;\r\n                border: none;\r\n            }\r\n        }\r\n\r\n        .loadingIcon {\r\n            width: 100px;\r\n            height: 100px;\r\n            left: 50% !important;\r\n            top: 50% !important;\r\n\r\n            margin-top: -50px;\r\n            margin-left: -50px;\r\n\r\n            font-size: 5px;\r\n            text-indent: -9999em;\r\n            border-top: 1.1em solid rgba(3,0,2, 0.2);\r\n            border-right: 1.1em solid rgba(3,0,2, 0.2);\r\n            border-bottom: 1.1em solid rgba(3,0,2, 0.2);\r\n            border-left: 1.1em solid #030002;\r\n            -webkit-transform: translateZ(0);\r\n            -ms-transform: translateZ(0);\r\n            transform: translateZ(0);\r\n            -webkit-animation: load8 1.1s infinite linear;\r\n            animation: load8 1.1s infinite linear;\r\n\r\n            border-radius: 50%;\r\n            &:after {\r\n                border-radius: 50%;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n\r\n    .hidden, [hidden] {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes load8 {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n@keyframes load8 {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.viewer-pdf-viewer {\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    outline: none;\r\n}\r\nhtml[dir='ltr'] .viewer-pdf-viewer {\r\n    box-shadow: inset 1px 0 0 hsla(0,0%,100%,.05);\r\n}\r\nhtml[dir='rtl'] .viewer-pdf-viewer {\r\n    box-shadow: inset -1px 0 0 hsla(0,0%,100%,.05);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
